import { Injector, Component, ViewEncapsulation, Inject } from '@angular/core';

import { AppConsts } from '@shared/AppConsts';
import { AppComponentBase } from '@shared/common/app-component-base';

import { DOCUMENT } from '@angular/common';

@Component({
  templateUrl: './theme8-brand.component.html',
  selector: 'theme8-brand',
  encapsulation: ViewEncapsulation.None,
})
export class Theme8BrandComponent extends AppComponentBase {
  remoteServiceBaseUrl: string = AppConsts.remoteServiceBaseUrl;

  constructor(
    injector: Injector,
    @Inject(DOCUMENT) private document: Document
  ) {
    super(injector);
  }

  clickTopbarToggle(): void {
    this.document.body.classList.toggle('m-topbar--on');
  }
}
